import React from 'react';
import { useInView } from '@/hooks/useInView';

const LOGOS = [
  { name: "Mabe", src: "https://customer-assets.emergentagent.com/job_ff005761-8ac3-4660-9dad-114860e1014d/artifacts/6nyskihl_Mabe-Logos_Logo-Black-1.avif" },
  { name: "InsightHealth", src: "https://customer-assets.emergentagent.com/job_ff005761-8ac3-4660-9dad-114860e1014d/artifacts/6fz75a9t_Insight.png.png" },
  { name: "K Star Vinyl Fencing", src: "https://customer-assets.emergentagent.com/job_sara-ads-consultant/artifacts/7mnu67zc_320241542_672511491091300_6969492486650865235_n.webp" },
  { name: "Ramsey Asphalt Construction", src: "https://customer-assets.emergentagent.com/job_sara-ads-consultant/artifacts/b5gxckdu_903x240-RACC-Logo.png" },
  { name: "Client Partner", src: "https://customer-assets.emergentagent.com/job_sara-ads-consultant/artifacts/72v85268_logo.svg" },
];

export const LogosBanner = () => {
  const [ref, isInView] = useInView();
  const duplicated = [...LOGOS, ...LOGOS, ...LOGOS];

  return (
    <section data-testid="logos-banner" className="py-12 lg:py-16 bg-secondary overflow-hidden" ref={ref}>
      <div className={`text-center mb-8 px-4 transition-all duration-700 ${isInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}>
        <h3 className="text-foreground text-xl sm:text-2xl font-bold">
          Businesses I've Consulted On
        </h3>
      </div>
      <div className="flex animate-marquee-logos items-center whitespace-nowrap">
        {duplicated.map((logo, i) => (
          <div
            key={i}
            className="flex-shrink-0 mx-8 sm:mx-12 grayscale hover:grayscale-0 opacity-60 hover:opacity-100"
            style={{ transition: 'filter 0.3s ease, opacity 0.3s ease' }}
          >
            <img
              src={logo.src}
              alt={logo.name}
              className="h-12 sm:h-16 max-w-[160px] object-contain"
              loading="lazy"
            />
          </div>
        ))}
      </div>
    </section>
  );
};
